"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReviewTab = void 0;
const core_1 = require("@material-ui/core");
const asset_list_1 = require("client/components/asset-list");
const asset_list_overview_1 = require("client/components/asset-list-overview");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/inventory/modules/inventory-list/store");
const store_3 = require("client/modules/ledger/store");
const store_4 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const CheckCircle_1 = require("material-ui-icons/CheckCircle");
const Done_1 = require("material-ui-icons/Done");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const permissions_1 = require("shared/permissions");
const po_distributor_email_template_1 = require("shared/po-distributor-email-template");
const purchase_order_1 = require("shared/purchase-order");
const capitalize_string_1 = require("shared/util/capitalize-string");
const formatUsd_1 = require("shared/util/formatUsd");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
const back_order_modal_1 = require("./components/back-order-modal");
const iframe_preview_1 = require("./components/iframe-preview");
const label_1 = require("./components/label");
const order_receive_scan_1 = require("./components/order-receive-scan");
const order_tracking_detail_1 = require("./components/order-tracking-detail");
const shipping_method_label_1 = require("./components/shipping-method-label");
require("./order-review.less");
const orderReviewColumnsTmp = [
    {
        id: "ndcpackage",
        label: "ndc pkg"
    },
    {
        id: "name",
        label: "name"
    },
    {
        id: "qty-on-hand",
        label: "qty on hand"
    },
    {
        id: "user",
        label: "user"
    },
    {
        id: "date",
        label: "date"
    },
    {
        id: "distributor",
        label: "distributor"
    },
    {
        id: "price",
        label: "price"
    },
    {
        id: "quantity",
        label: "order qty"
    },
    {
        id: "received",
        label: "total received"
    },
    {
        id: "total",
        label: "total cost"
    },
    {
        id: "empty",
        label: ""
    }
];
const orderReviewColumns = [
    {
        id: "ndcpackage",
        label: "ndc pkg"
    },
    {
        id: "name",
        label: "name"
    },
    {
        id: "description",
        label: "description"
    },
    {
        id: "qty-on-hand",
        label: "qty on hand"
    },
    {
        id: "user",
        label: "user"
    },
    {
        id: "date",
        label: "date"
    },
    {
        id: "distributor",
        label: "distributor"
    },
    {
        id: "quantity",
        label: "order qty"
    },
    {
        id: "received",
        label: "total received"
    },
    {
        id: "empty",
        label: ""
    }
];
let OrderReviewTab = class OrderReviewTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.uploadModal = false;
        this.assetModal = false;
        this.scanModal = false;
        this.invoiceMetas = [];
        this.showEmailQueueConfirmation = false;
        this.showConfirmApprove = false;
        this.showConfirmApproveDoubleCheck = false;
        this.showConfirmReject = false;
        this.rejectionReason = "";
        this.renderPlaceHolder = false;
        this.loading = false;
        this.invoiceStatus = new Map();
        this.invoiceStatusInitial = new Map();
        this.showRows = new Map();
        this.manageLotMode = true;
        this.newLot = {
            expireDate: "",
            lotNumber: "",
            quantity: 0
        };
        this.createLotClickedInventoryId = null;
        this.inventoriesLots = new Map();
        this.batchQtyReceived = 0;
        this.availableLots = [];
        this.iframeUrl = "";
        this.invoiceDocumentViewing = null;
        this.isLoading = false;
        this.createLotShow = false;
        this.showOrderTrackingModal = false;
        this.showBackorderModal = false;
        this.backorderInventory = null;
        this.showReplacementModal = false;
        // C-046.207_UAT 25/07/2025
        this.isDistributor = false;
        // C-090
        this.qtysubTotal = [];
        this.loadInventorySiteLots = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 1000,
                order: "",
                search: "",
                siteId: this.purchaseOrder.site.id,
                sort: "",
                start: 0,
                where: ``
            };
            await store_2.inventoryListStore.loadInventorySiteLots(options);
            this.initializeInventorySiteLots();
        });
        this.handleSaveRow = throttle_debounce_1.debounce(200, async (poInventory) => {
            const lotsObj = this.inventoriesLots.has(poInventory.inventorySiteId) &&
                this.inventoriesLots.get(poInventory.inventorySiteId);
            const lots = lotsObj ? Object.values(lotsObj) : [];
            this.isLoading = true;
            try {
                await store_2.inventoryListStore.saveInventorySiteLots(lots, this.purchaseOrder);
                if (this.batchQtyReceived > 0) {
                    await store_2.inventoryListStore.updatePoInventoryAndSiteInventory(poInventory, this.batchQtyReceived, this.purchaseOrder.id);
                }
                await this.loadInventorySiteLots();
                await this.loadPurchaseOrder();
                this.resetShowRows();
                this.isLoading = false;
            }
            catch (e) {
                console.error("Error updating inventory qty", e);
                this.isLoading = false;
            }
        });
        this.updateUi = async () => {
            await this.loadInventorySiteLots();
            await this.loadPurchaseOrder();
            this.resetShowRows();
        };
        this.loadPurchaseOrder = async () => {
            const transactionId = this.props.params[0];
            if (transactionId === "0") {
                this.renderPlaceHolder = true;
            }
            else {
                this.renderPlaceHolder = false;
                this.purchaseOrder = await store_1.inventoryOrderStore.loadPurchaseOrderById(parseInt(transactionId, 10));
                const query = {
                    poId: parseInt(transactionId, 10)
                };
                await store_1.inventoryOrderStore.listInvoices(query);
                this.invoiceMetas = store_1.inventoryOrderStore.invoiceMetas;
                this.initializeInvoiceStatus();
            }
        };
        this.initializeShowRows = () => {
            this.showRows.clear();
            const { orderInventories } = this.purchaseOrder;
            if (orderInventories === null || orderInventories === void 0 ? void 0 : orderInventories.length) {
                for (const inventory of this.purchaseOrder.orderInventories) {
                    this.showRows.set(inventory.id, false);
                }
            }
        };
        this.initializeInvoiceStatus = () => {
            const { purchaseOrderDistributorInvoices: invoices } = this.purchaseOrder;
            for (const invoice of invoices) {
                this.invoiceStatus.set(invoice.id, !!invoice.productReceived);
            }
            this.invoiceStatusInitial = new Map(this.invoiceStatus);
        };
        this.initializeInventorySiteLots = () => {
            const { inventorySiteLots: { value: lots = [] } } = store_2.inventoryListStore;
            // reset this.inventoriesLots before re-initializing.
            this.inventoriesLots.clear();
            this.batchQtyReceived = store_1.inventoryOrderStore.currentBatchQtyEdit || 0;
            // UPDATE currentBatchQtyEdit (should only use if new lot added)
            store_1.inventoryOrderStore.currentBatchQtyEdit = 0;
            for (const lot of lots) {
                const { inventorySiteId } = lot;
                if (this.inventoriesLots.has(inventorySiteId)) {
                    const inventoriesLots = Object.assign({}, this.inventoriesLots.get(inventorySiteId));
                    inventoriesLots[lot.id] = ramda_1.clone(lot);
                    inventoriesLots[lot.id].quantity = 0;
                    this.inventoriesLots.set(inventorySiteId, inventoriesLots);
                }
                else {
                    const inventoriesLots = {};
                    inventoriesLots[lot.id] = ramda_1.clone(lot);
                    inventoriesLots[lot.id].quantity = 0;
                    this.inventoriesLots.set(inventorySiteId, inventoriesLots);
                }
            }
        };
        this.handleUploadClick = () => {
            this.uploadModal = true;
        };
        this.handleReplacementOrder = async () => {
            this.showReplacementModal = false;
            await store_3.ledgerStore.replacementOrder(this.purchaseOrder);
            await this.loadPurchaseOrder();
        };
        this.handleScanModalClick = () => {
            this.scanModal = true;
        };
        this.handleAssetModalClick = () => {
            this.assetModal = true;
        };
        this.handleManageOrderTracking = () => {
            this.showOrderTrackingModal = true;
        };
        this.renderTrackingLinks = () => store_1.inventoryOrderStore.orderTrackingDetails.map((trackingDetail, index) => {
            const { trackingNumber, trackingLink, expectedDate, distributor: { distributor }, shippingCost } = trackingDetail;
            return (React.createElement("div", { key: index },
                React.createElement("span", null,
                    distributor,
                    ` | `,
                    formatUsd_1.formatUsd(shippingCost),
                    ` | `),
                React.createElement("a", { href: this.normalizeTrackingLink(trackingLink), target: "_blank" }, `${trackingNumber}`),
                expectedDate ? (React.createElement("span", null,
                    ` | `,
                    moment(expectedDate).format("MM/DD/YYYY"))) : null));
        });
        this.renderTrackingCredits = () => store_1.inventoryOrderStore.orderTrackingCreditDetails.map((creditDetail, index) => {
            const { creditNumber, note, distributor: { distributor }, creditAmount } = creditDetail;
            return (React.createElement("div", { key: index },
                React.createElement("span", null,
                    distributor,
                    ` | `,
                    `-${formatUsd_1.formatUsd(creditAmount)}`,
                    ` | `),
                React.createElement("span", { "data-tip": note }, creditNumber)));
        });
        this.normalizeTrackingLink = (trackingLink) => {
            const re = /https?:\/\//g;
            const containsProtocol = re.test(trackingLink);
            if (containsProtocol) {
                return trackingLink;
            }
            const assumeLink = `http://${trackingLink}`;
            return assumeLink;
        };
        this.missingDistributor = () => {
            const { orderInventories } = this.purchaseOrder;
            return ((orderInventories === null || orderInventories === void 0 ? void 0 : orderInventories.length) && !orderInventories.every(oi => oi.distributor));
        };
        this.renderOrderReviewPage = () => {
            const isIMBUser = store_4.usersStore.user && store_4.usersStore.user.value && store_4.usersStore.user.value.user;
            if (!this.purchaseOrder) {
                return React.createElement("div", null);
            }
            // C-090
            const qts = [];
            const orderInventoryTotal = this.purchaseOrder.orderInventories.map((qty) => {
                qts.push(qty === null || qty === void 0 ? void 0 : qty.inventoryOrderQuantity);
            });
            const qtysubTotal = qts === null || qts === void 0 ? void 0 : qts.reduce((acc, val) => {
                return acc + val;
            });
            const { id, pharmacyName, rejectionReason, submissionDate, note, purchaseOrderDistributorInvoices: invoices, orderTotalCost, customerPONumber, transactionPONumber, approvalStatus, user, shippingMethods, approved, // C-090
            approvalDate // C-090
             } = this.purchaseOrder;
            const productReceived = (invoices === null || invoices === void 0 ? void 0 : invoices.length) &&
                invoices.every((invoice) => invoice.productReceived);
            const productPartialReceived = (invoices === null || invoices === void 0 ? void 0 : invoices.length) &&
                invoices.some((invoice) => invoice.productReceived);
            const isTmp = store_4.usersStore.user.value.user;
            // c-090
            const footerRow = [
                {
                    poIsApproved: approved,
                    isTmp: isTmp,
                    poHasBeenApproved: approvalDate,
                    orderTotalCost: orderTotalCost,
                    ordQtyTotal: qtysubTotal
                }
            ];
            const approverButtons = store_4.usersStore.permissions.UpdateOrderApprover && (React.createElement("div", null,
                React.createElement(button_1.MaterialButton, { disabled: approvalStatus === "rejected" ||
                        approvalStatus === "approved" ||
                        this.loading, secondary: true, onClick: () => (this.showConfirmReject = true) }, "Reject"),
                React.createElement(button_1.MaterialButton, { disabled: approvalStatus === "rejected" ||
                        approvalStatus === "approved" ||
                        this.loading, primary: true, onClick: () => (this.showConfirmApproveDoubleCheck = true) }, "Approve"))); // E-026 C-036.1
            return (React.createElement("div", { className: "inventory-order__quick-order" },
                React.createElement("div", { className: "overlay-container" },
                    React.createElement("div", { className: `overlay ${approvalStatus === "rejected"
                            ? "overlay--rejected"
                            : approvalStatus === "approved"
                                ? "overlay--approved"
                                : "overlay--hide"}` }),
                    React.createElement("div", { className: "review-order-header--review-order" },
                        React.createElement("div", { className: "review-order-header__heading" },
                            React.createElement(label_1.Label, { label: "Pharmacy Name", value: pharmacyName }),
                            React.createElement(label_1.Label, { label: "Transaction Id", value: id }),
                            React.createElement(label_1.Label, { label: "Submission Date", value: moment(new Date(submissionDate)).format("MM/DD/YYYY") }),
                            React.createElement(label_1.Label, { label: "Trans PO #", value: transactionPONumber !== null && transactionPONumber !== void 0 ? transactionPONumber : "n/a" }),
                            React.createElement(label_1.Label, { label: "Cust PO #", value: customerPONumber !== null && customerPONumber !== void 0 ? customerPONumber : "n/a" }),
                            React.createElement(label_1.Label, { label: "Status", value: approvalStatus }),
                            approvalStatus === "approved" && (React.createElement(React.Fragment, null,
                                React.createElement(label_1.Label, { label: "Submitted by", value: user
                                        ? `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`
                                        : "" }),
                                React.createElement(label_1.Label, { label: "Invoice email status", value: "" }, this.renderInvoiceEmailStatus()),
                                React.createElement(label_1.Label, { label: "Products Received", value: productReceived
                                        ? "yes"
                                        : productPartialReceived
                                            ? "partial"
                                            : "no" }))),
                            React.createElement(label_1.Label, { label: "Order Tracking", onClick: isTmp ? this.handleManageOrderTracking : null, value: isTmp ? "Manage Order Tracking" : "" },
                                this.renderTrackingLinks(),
                                this.renderTrackingCredits())),
                        React.createElement("div", { className: "order-review-messages" },
                            React.createElement("div", null,
                                React.createElement("div", { className: "note" },
                                    React.createElement(core_1.Typography, { variant: "subheading" }, "Order note"),
                                    React.createElement("textarea", { disabled: true, value: note !== null && note !== void 0 ? note : "No note provided...", rows: 4, cols: 50 })),
                                approvalStatus === "rejected" && (React.createElement("div", { className: "note" },
                                    React.createElement(core_1.Typography, { variant: "subheading" }, "Reason for rejection"),
                                    React.createElement("textarea", { disabled: true, value: rejectionReason !== null && rejectionReason !== void 0 ? rejectionReason : "No reason provided...", rows: 4, cols: 50 })))),
                            React.createElement("div", { className: "shipping-methods" },
                                React.createElement(core_1.Typography, { variant: "subheading" }, "Shipping Methods"),
                                React.createElement(shipping_method_label_1.ShippingMethodLabel, { shippingMethods: shippingMethods }))),
                        isIMBUser ? (React.createElement("div", { className: "review-order-header--review-order__actions--review" },
                            React.createElement(button_1.MaterialButton, { disabled: approvalStatus === "rejected" ||
                                    approvalStatus === "approved" ||
                                    this.loading, flat: true, onClick: this.handlePoEdit }, "Edit"),
                            approverButtons)) : (approvalStatus === "rejected" && (React.createElement("div", { className: "review-order-header--review-order__actions--review" },
                            React.createElement(button_1.MaterialButton, { secondary: true, onClick: this.handlePoEdit }, "Edit")))))),
                approvalStatus === "approved" && (React.createElement("div", { className: "update-product-received-container" },
                    React.createElement("div", { className: "update-product-received" },
                        React.createElement("div", { className: "update-product-received__headline" },
                            React.createElement(core_1.Typography, { variant: "headline" }, "Product Received Status")),
                        React.createElement("div", { className: "update-product-received__body" },
                            React.createElement("div", { className: "update-product-received__distributor" }, invoices === null || invoices === void 0 ? void 0 : invoices.map((invoice, index) => this.renderInvoicesStatus(invoice, index))))),
                    React.createElement("div", { className: "product-received-btn-container" },
                        React.createElement(button_1.MaterialButton, { flat: true, onClick: this.handleScanModalClick }, "scan"),
                        [permissions_1.GROUPS.DEV, permissions_1.GROUPS.ADMIN].includes(store_4.usersStore.user.value.groupId) &&
                            !this.purchaseOrder.note.includes("REPLACEMENT") && (React.createElement(button_1.MaterialButton, { flat: true, onClick: () => {
                                this.showReplacementModal = true;
                            } }, "Replacement Order")),
                        React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: "Edit Invoice", onClick: this.handleAssetModalClick }, this.renderInvoiceListRow())))),
                this.renderOrderReviewList(),
                isTmp ? (React.createElement("div", { className: "edit-review-order-list" },
                    React.createElement(list_1.MaterialList
                    // columns={isTmp ? columnsTmp : columns}
                    , { 
                        // columns={isTmp ? columnsTmp : columns}
                        order: "ASC", orderBy: "", rows: footerRow || [], renderRow: this.renderOrderReviewListRowFooter, resizableheader: true, customClass: "custom-material-list__order-review-list" }))) : null));
        };
        this.renderInvoiceListRow = () => this.invoiceMetas && this.invoiceMetas.length
            ? this.invoiceMetas.map((invoiceUpload, index) => (React.createElement("li", { "data-tip": invoiceUpload.originalname, onClick: () => {
                    this.iframeUrl = invoiceUpload.path;
                    this.invoiceDocumentViewing = invoiceUpload;
                }, key: index }, invoiceUpload.description || invoiceUpload.originalname)))
            : null;
        this.handlePoEdit = () => {
            store_1.inventoryOrderStore.purchaseOrderToEdit = this.purchaseOrder;
            router_1.RouteManager.transitionTo("/order/quickorder");
        };
        this.isChangedInvoiceStatus = () => {
            for (const [key, value] of this.invoiceStatus) {
                if (this.invoiceStatusInitial.get(key) !== value) {
                    return true;
                }
            }
            return false;
        };
        this.handleUpdateInvoiceStatus = (invoice) => () => {
            const { productReceived } = invoice;
            const checked = this.invoiceStatus.has(invoice.id) && this.invoiceStatus.get(invoice.id);
            this.invoiceStatus.set(invoice.id, productReceived ? true : !checked);
        };
        this.renderInvoicesStatus = (invoice, index) => {
            const { purchaseDistributor } = invoice;
            const distributor = purchaseDistributor
                ? purchaseDistributor.distributor
                : "";
            const invoiceProductsReceived = invoice.productReceived;
            return (React.createElement("div", { key: index, className: "order-received-distributor-overview" },
                React.createElement(CheckCircle_1.default, { className: `order-received-distributor-overview__icon${invoiceProductsReceived
                        ? " order-received-distributor-overview__icon--received"
                        : ""}` }),
                React.createElement(core_1.Typography, { className: "order-received-distributor-overview__name" }, distributor)));
        };
        this.handleDeleteInvoiceDocument = async (upload) => {
            if (this.invoiceDocumentViewing) {
                const { id } = this.invoiceDocumentViewing;
                await store_1.inventoryOrderStore.deleteInvoiceDocument(id);
                await this.loadPurchaseOrder();
                this.iframeUrl = "";
            }
            if (upload) {
                await store_1.inventoryOrderStore.deleteInvoiceDocument(upload);
                await this.loadPurchaseOrder();
            }
        };
        this.renderReplacementModal = () => {
            var _a;
            if (!this.showReplacementModal)
                return;
            const cancelBtn = (React.createElement(button_1.MaterialButton, { onClick: () => {
                    this.showReplacementModal = false;
                } }, "Cancel"));
            const submitBtn = (React.createElement(button_1.MaterialButton, { primary: true, style: { marginLeft: "1em" }, onClick: this.handleReplacementOrder }, "Submit"));
            const buttons = [cancelBtn, submitBtn];
            const price = (_a = this.purchaseOrder) === null || _a === void 0 ? void 0 : _a.orderTotalCost;
            return (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => {
                    this.showReplacementModal = false;
                } },
                React.createElement("div", { style: { width: "20em" } },
                    React.createElement("h3", { style: { textAlign: "center" } }, "ALERT"),
                    "You're about to return ",
                    React.createElement("strong", null, formatUsd_1.formatUsd(price)),
                    " to the ledger for this order, confirming it as a replacement order.")));
        };
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.invoiceDocumentViewing = null;
        };
        //46.200 lavk2 2025-03-18 19:23:02
        this.renderDistributorWarning = () => {
            const { orderInventories } = this.purchaseOrder;
            return this.missingDistributor()
                ? `
  <p>Missing distributor selection from the following inventories</p>
  ${orderInventories
                    .filter(oi => !oi.distributor)
                    .map(oi => `<span>${uppercase_string_1.uppercaseString(oi.name)}</span>`)
                    .join(", ")}
  `
                : "";
        };
        //46.200 lavk2 2025-03-18 19:23:02
        // <a class='pharmLink' href = "/order/distributors" target="_blank">
        this.renderDistributorWarningDoubleCheck = () => {
            var _a, _b;
            const { orderInventories } = this.purchaseOrder;
            return this.missingDistributor() ? `
  <p>Missing distributor selection from the following inventories</p>
  ${orderInventories.filter(oi => !oi.distributor).map(oi => `<span>${uppercase_string_1.uppercaseString(oi.name)}</span>`).join(", ")}
  <p>
  <span>
    <a class='pharmLink' href = "/pharmacies/${(_b = (_a = this.purchaseOrder) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.id}/distributors" target="_blank">
      Click here
    </a>

    to assign a distributor.
    </span>
</p>
<br/>
  <div>
    Click submit to proceed with the approval.
  </div>
  ` : "";
        };
        this.renderDistributorRedirect = () => this.missingDistributor() ? (React.createElement("p", null)) : null;
        this.renderInvoiceEmailStatus = () => {
            if (!this.purchaseOrder) {
                return "";
            }
            const { purchaseOrderDistributorInvoices = [] } = this.purchaseOrder;
            const invoices = purchaseOrderDistributorInvoices.filter(invoice => invoice.mailMessageMailID);
            return invoices.length
                ? invoices.map(invoice => {
                    const { purchaseDistributor, orderSentToDistributor } = invoice;
                    const distributor = purchaseDistributor
                        ? purchaseDistributor.distributor
                        : "";
                    const mailId = invoice.mailMessageMailID;
                    const { poMailMessages = [] } = store_1.inventoryOrderStore;
                    if (mailId) {
                        const mailMessageFound = poMailMessages.find(mm => mm.MailID === mailId);
                        if (mailMessageFound) {
                            const { MailID, MailSent, MailRead, MailDeleted, ProblemMessage, FailedCount } = mailMessageFound;
                            const isError = !MailSent && Boolean(ProblemMessage);
                            const statusText = MailSent
                                ? "Sent"
                                : isError
                                    ? "Error"
                                    : "Pending";
                            return (React.createElement(core_1.Typography, null, `${distributor}: ${statusText} (MailID ${MailID})`));
                        }
                    }
                    const statusText = orderSentToDistributor ? "Sent" : "Pending";
                    return (React.createElement(core_1.Typography, null, `${distributor}: ${statusText} (MailID ${mailId})`));
                })
                : "No invoices found";
        };
        this.renderEmailQueueMessage = () => {
            if (!this.purchaseOrder) {
                console.error("inside renderEmailQueueMessage, this.purchaseOrder is", this.purchaseOrder);
                return "";
            }
            const { purchaseOrderDistributorInvoices = [] } = this.purchaseOrder;
            const invoices = purchaseOrderDistributorInvoices.filter(invoice => invoice.mailMessageMailID);
            return invoices.length
                ? `<p style={textAlign: left}>The following distributors have queuing email orders:</p>
      ${invoices.map(invoice => {
                    const { purchaseDistributor } = invoice;
                    const distributor = purchaseDistributor
                        ? purchaseDistributor.distributor
                        : "";
                    const mailId = invoice.mailMessageMailID;
                    return `<strong>${distributor}</strong>: Mail id ${mailId} on queue.`;
                })}
      <br />
      <p>Please contact your admin if email queue is missing.</p>
      `
                : "No purchase order emails on queue to be sent to the distributors. Please contact your admin for help.";
        };
        this.handleOrderReceiveScanSubmit = async (submitMetas) => {
            for (const meta of submitMetas) {
                const { poInventory, currentReceivedQty, lotNumber, lotExp } = meta;
                if (poInventory.totalQtyReceived >= poInventory.inventoryOrderQuantity) {
                    console.info("All order qty received. Skipping");
                    continue;
                }
                const newLotMeta = {
                    inventoryId: poInventory.inventoryId,
                    newLot: {
                        expireDate: lotExp,
                        lotNumber,
                        quantity: currentReceivedQty
                    },
                    siteId: this.purchaseOrder.site.id
                };
                await store_2.inventoryListStore.updateInventorySiteLotFromBarcode(newLotMeta);
                await store_2.inventoryListStore.updatePoInventoryAndSiteInventory(poInventory, currentReceivedQty, this.purchaseOrder.id);
            }
            await this.loadInventorySiteLots();
            await this.loadPurchaseOrder();
            this.scanModal = false;
        };
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_1.inventoryOrderStore.updateAssetsDescriptions(uploads);
            await this.loadPurchaseOrder();
        };
        this.handleInvoiceUpload = async (accepted) => {
            await store_1.inventoryOrderStore.uploadInvoice(accepted, String(this.purchaseOrder.id));
            await this.loadPurchaseOrder();
        };
        this.handleOrderTrackingSubmit = async (trackingDetails, creditDetails) => {
            await store_1.inventoryOrderStore.saveOrderTrackingDetails(trackingDetails, creditDetails, this.purchaseOrder.id, this.purchaseOrder.site);
            await store_1.inventoryOrderStore.listOrderTrackingDetails(this.purchaseOrder.id);
            await store_1.inventoryOrderStore.listOrderTrackingCreditDetails(this.purchaseOrder.id);
        };
        this.handleOrderTrackingCreate = async (newTrackingDetail) => {
            await store_1.inventoryOrderStore.addOrderTrackingDetail(newTrackingDetail, this.purchaseOrder.id, this.purchaseOrder.site);
            await store_1.inventoryOrderStore.listOrderTrackingDetails(this.purchaseOrder.id);
            await store_1.inventoryOrderStore.listOrderTrackingCreditDetails(this.purchaseOrder.id);
        };
        this.handleOrderTrackingCreditCreate = async (newCreditDetail) => {
            await store_1.inventoryOrderStore.addOrderTrackingCreditDetail(newCreditDetail, this.purchaseOrder.id, this.purchaseOrder.site);
            await store_1.inventoryOrderStore.listOrderTrackingDetails(this.purchaseOrder.id);
            await store_1.inventoryOrderStore.listOrderTrackingCreditDetails(this.purchaseOrder.id);
        };
        this.handleStringChange = (field) => (event) => {
            if (field === "rejectionReason") {
                this.rejectionReason = event.currentTarget.value;
            }
        };
        this.reasonTextField = () => (React.createElement(text_area_1.MaterialTextArea, { placeholder: "*Please provide a reason...", value: this.rejectionReason, onChange: this.handleStringChange("rejectionReason") }));
        this.sendEmailTemplatesToDistributors = async (purchaseOrder) => {
            var _a, _b;
            const orderInventoryDistributors = {};
            const { shippingMethods } = purchaseOrder;
            // Omit canceled inventories
            let orderInventories = (_a = purchaseOrder.orderInventories) !== null && _a !== void 0 ? _a : [];
            orderInventories = orderInventories.filter(poInventory => !poInventory.canceledAt);
            // Map out distributor object with values as inventories related to that distributor.
            for (const inventory of orderInventories) {
                const distributor = inventory.distributor
                    ? inventory.distributor
                    : "NO_DISTRIBUTOR_SELECTED";
                if (orderInventoryDistributors.hasOwnProperty(distributor)) {
                    orderInventoryDistributors[distributor] = [
                        ...orderInventoryDistributors[distributor],
                        inventory
                    ];
                }
                else {
                    orderInventoryDistributors[distributor] = [inventory];
                }
            }
            const emailTemplates = {};
            // Map out email template organized by distributors.
            for (const distributor in orderInventoryDistributors) {
                if (orderInventoryDistributors.hasOwnProperty(distributor)) {
                    const distributorInventories = orderInventoryDistributors[distributor].map((inventory) => ({
                        id: inventory.id,
                        inventoryOrderQuantity: inventory.inventoryOrderQuantity,
                        name: inventory.name,
                        pkgCode: inventory.pkgCode,
                        poNumber: purchaseOrder.id,
                        price: inventory.price,
                        inventoryTotalCost: inventory.inventoryTotalCost,
                    }));
                    // Query for site and account number
                    const { site } = purchaseOrder;
                    const siteDistributor = site
                        ? site.siteDistributors.find((siteDistributor) => siteDistributor.distributor.distributor === distributor)
                        : null;
                    const siteName = site
                        ? `${site.displayName}`
                        : "site address not found";
                    const siteAddress = site
                        ? `${site.address}, ${site.city}, ${site.state}, ${site.zip}` // C-022.15
                        : "site address not found";
                    const accountNumber = siteDistributor
                        ? siteDistributor.accountNumber
                        : "account Number not found";
                    const shippingMethodFound = (shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.length) ? shippingMethods.find(method => method.distributor === distributor)
                        : null;
                    const inventoryTable = po_distributor_email_template_1.buildDistributorPOTable(distributorInventories, siteName, siteAddress, accountNumber, (_b = purchaseOrder.note) !== null && _b !== void 0 ? _b : "", shippingMethodFound);
                    const subject = "Purchase order request";
                    const title = `Purchase order for ${distributor}`; //C-022.15
                    const body = inventoryTable;
                    const distributorOrderEmailTemplate = po_distributor_email_template_1.getDistributorPOEmailTemplate(subject, title, body);
                    emailTemplates[distributor] = distributorOrderEmailTemplate.trim();
                }
            }
            const distributorOrders = {
                emailTemplates,
                orderInventoryDistributors,
                purchaseOrder,
                siteId: purchaseOrder.siteId
            };
            await store_1.inventoryOrderStore.sendEmailOrderToDistributors(distributorOrders);
        };
        this.handleNewLotChange = (field) => (event, value) => {
            switch (field) {
                case "lotNumber":
                    this.newLot[field] = value;
                case "quantity":
                    this.newLot[field] = value;
                default:
            }
        };
        this.handleNewLotDateChange = (field) => (value) => {
            if (field === "expireDate") {
                const formattedDate = this.formatDate(value);
                this.newLot.expireDate = formattedDate;
            }
        };
        this.handleCancelCreateLot = () => {
            this.resetNewLot();
        };
        this.renderCreateLotUi = (inventory, site, poInventory) => {
            var _a;
            const { lotNumber, expireDate, quantity } = this.newLot;
            const shouldDisableNewLotSave = !lotNumber || !expireDate || (!quantity && quantity !== 0);
            const { name = "", displayName = "" } = site;
            return (React.createElement(modal_1.Modal, { onCancel: this.handleCancelCreateLot },
                React.createElement("div", { className: "lot-add-form-container" },
                    React.createElement("div", null,
                        React.createElement(core_1.Typography, { variant: "display1" }, "Create Lot"),
                        React.createElement("div", { className: "lot-add-form-container__site" },
                            React.createElement(core_1.Typography, { variant: "body2" }, name || displayName)),
                        React.createElement("div", { className: "lot-add-form-container__inventory" },
                            React.createElement(core_1.Typography, { variant: "caption" },
                                inventory.group,
                                " |",
                                " ", (_a = inventory.strengthDescription) !== null && _a !== void 0 ? _a : inventory.name),
                            React.createElement(core_1.Typography, { variant: "caption" },
                                inventory.package,
                                " | ",
                                inventory.dosage))),
                    React.createElement("div", { className: "lot-add-form" },
                        React.createElement(text_field_1.MaterialTextField, { className: "lot-add-form__item lot-add-form__lot-number", label: "Lot #", onChange: this.handleNewLotChange("lotNumber"), value: this.newLot.lotNumber }),
                        React.createElement(date_picker_1.MaterialDatePicker, { className: "lot-add-form__item lot-add-form__expire-date", label: "Expiration Date", onChange: this.handleNewLotDateChange("expireDate"), value: this.newLot.expireDate })),
                    React.createElement(button_1.MaterialButton, { flat: true, primary: true, disabled: shouldDisableNewLotSave, className: "lot-add-form__btn", onClick: this.handleNewLotCreate(poInventory) }, "Create Lot"))));
        };
        this.handleNewLotCreate = (poInventory) => async () => {
            const { inventorySiteId } = poInventory;
            store_1.inventoryOrderStore.currentBatchQtyEdit = this.batchQtyReceived;
            const { inventoryId } = poInventory;
            const { site } = this.purchaseOrder;
            this.newLot.quantity = 0;
            const newLotMeta = {
                inventoryId,
                newLot: Object.assign({}, this.newLot),
                siteId: site.id
            };
            const newInventorySiteLot = await store_2.inventoryListStore.addInventorySiteLot(newLotMeta);
            if (this.inventoriesLots.has(inventorySiteId)) {
                const inventoriesLots = Object.assign({}, this.inventoriesLots.get(inventorySiteId));
                inventoriesLots[newInventorySiteLot.id] = newInventorySiteLot;
                this.inventoriesLots.set(inventorySiteId, inventoriesLots);
            }
            else {
                const inventoriesLots = {};
                inventoriesLots[newInventorySiteLot.id] = newInventorySiteLot;
                this.inventoriesLots.set(inventorySiteId, inventoriesLots);
            }
            this.resetNewLot();
        };
        // C-022.1 order approve initiated from this method same as prious
        this.handleDecision = (decision) => async () => {
            this.loading = true;
            const purchaseOrderDecision = {
                decision,
                purchaseOrder: this.purchaseOrder,
                rejectionReason: this.rejectionReason
            };
            // get all distributors in this po
            const distIds = [];
            for (const dist of this.purchaseOrder.shippingMethods) {
                distIds.push(dist.id);
            }
            // C-046All options are non selectable after Reject > Error > Back to review C-046.2065
            if (!distIds[0] && this.rejectionReason.length) {
                this.showConfirmApproveDoubleCheck = false;
                this.loading = false;
            }
            // ... rest of the code
            else {
                const isDistDeleted = await store_1.inventoryOrderStore.checkDeletedDistributors(distIds);
                // if any dist is deleted, return
                if (isDistDeleted && isDistDeleted.length) {
                    this.showConfirmApproveDoubleCheck = false;
                    this.loading = false;
                    alert("Selected distributor(s) have been deleted. Please reject or edit order and resubmit for approval.");
                    return;
                }
            }
            const decisionResult = await store_1.inventoryOrderStore.updatePurchaseOrderStatus(purchaseOrderDecision);
            // check if any of the distributors has been deleted between submit for approval and approval time
            if (decisionResult) {
                // build and send email templates to distributors if order is approved and decisionResult did not error.
                // Send alert to site that made the po request.
                if (decision === "approve") {
                    await this.sendEmailTemplatesToDistributors(this.purchaseOrder);
                    await store_3.ledgerStore.orderLedger(this.purchaseOrder);
                    // Approval alert
                    await store_1.inventoryOrderStore.sendPurchaseOrderSubmissionDecisionAlert(this.purchaseOrder, "approved");
                }
                else {
                    // Rejection alert
                    await store_1.inventoryOrderStore.sendPurchaseOrderSubmissionDecisionAlert(this.purchaseOrder, "rejected");
                }
                // reset confirmation modals.
                this.showConfirmApprove = false;
                this.showConfirmApproveDoubleCheck = false;
                this.showConfirmReject = false;
                router_1.RouteManager.transitionTo("/order/history"); // C-033.16
                await this.loadPurchaseOrder();
                this.loading = false;
                this.showEmailQueueConfirmation = false; // make the PO Email queued notification pop-up not visible in UI Q-011 // C-033.16
            }
            else {
                console.error("Error in submitting approval decision for PO");
                alert("Error updating approval decision");
            }
        };
        this.handleRowClick = (row) => () => {
            if (!this.purchaseOrder ||
                this.purchaseOrder.approvalStatus !== purchase_order_1.POStatus.Approved) {
                return;
            }
            this.batchQtyReceived = 0;
            const isCurrentlyTrue = this.showRows.get(row.id);
            const setAllToFalse = () => {
                this.showRows.forEach((v, k) => {
                    this.showRows.set(k, false);
                });
            };
            if (row.canceledAt) {
                this.showRows.set(row.id, false);
                return;
            }
            if (isCurrentlyTrue) {
                setAllToFalse();
            }
            else {
                setAllToFalse();
                this.showRows.set(row.id, true);
            }
        };
        this.renderOrderReviewListRow = (row, index) => {
            const { pkgCode, name, distributor, quantityOnHand, price, inventoryOrderQuantity, inventoryTotalCost, totalQtyReceived, inventorySite, user, dateModified, canceledAt } = row;
            const isTmp = store_4.usersStore.user.value.user;
            const allProductsReceived = totalQtyReceived >= inventoryOrderQuantity;
            const poInventoryCanceled = row.canceledAt;
            const hasNotReceivedInventory = totalQtyReceived === 0;
            const poHasBeenApproved = this.purchaseOrder.approvalDate;
            const isActive = inventorySite ? Boolean(inventorySite.active) : false;
            const poIsApproved = this.purchaseOrder.approved;
            const { firstName: userFirstName, lastName: userLastName } = user !== null && user !== void 0 ? user : {
                firstName: "",
                lastName: ""
            };
            const shouldDisableBackorderButton = row.inventorySite &&
                row.inventorySite.backorderInventories &&
                Boolean(row.inventorySite.backorderInventories.length);
            const inventoryName = name;
            const userName = `${userFirstName} ${userLastName}`;
            const distributorName = distributor;
            const modifiedDate = dateModified
                ? moment(dateModified).format("MM-DD-YYYY")
                : "---";
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(list_item_1.MaterialListItem, { onClick: this.handleRowClick(row), className: `order-list-item${poInventoryCanceled
                        ? " order-list-item__canceled-accent"
                        : allProductsReceived
                            ? " order-list-item__received-accent"
                            : shouldDisableBackorderButton
                                ? " order-list-item__backorder-accent"
                                : ""}` },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: pkgCode }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: quantityOnHand }),
                    poIsApproved ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(userName) })) : null,
                    poIsApproved ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: modifiedDate })) : null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(distributorName) }),
                    isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: `${formatUsd_1.formatUsd(price)}` })) : null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: inventoryOrderQuantity }),
                    poIsApproved ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: totalQtyReceived })) : null,
                    isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: `${formatUsd_1.formatUsd(inventoryTotalCost)}` })) : null,
                    allProductsReceived && !canceledAt ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(Done_1.default, { "data-tip": "Cancel", color: "primary" }) })) : null,
                    isTmp &&
                        !row.canceledAt &&
                        hasNotReceivedInventory &&
                        poHasBeenApproved ? (React.createElement(list_item_text_1.MaterialListItemText, { onClick: this.handleCancelInventory(row), primary: React.createElement(icons_1.DeleteIcon, null) })) : isTmp &&
                        !row.canceledAt &&
                        hasNotReceivedInventory &&
                        !poHasBeenApproved ? null : !isTmp &&
                        !row.canceledAt &&
                        hasNotReceivedInventory ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: "" })) : !row.canceledAt &&
                        !hasNotReceivedInventory &&
                        !allProductsReceived ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: "Partial" })) : row.canceledAt ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: "CANCELED" })) : null),
                React.createElement(Collapse_1.default, { in: this.showRows.get(row.id) }, isActive ? (this.renderManageLots(row)) : (React.createElement(core_1.Typography, { color: "error", align: "center", variant: "subheading", gutterBottom: true }, `Inventory ${name} is not active, and cannot be updated.`)))));
        };
        // c-090
        this.renderOrderReviewListRowFooter = (row, index) => {
            const { poIsApproved, isTmp, poHasBeenApproved, orderTotalCost, ordQtyTotal } = row;
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(list_item_1.MaterialListItem, null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("span", { style: {
                                fontWeight: "bold",
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                            } },
                            "Total",
                            " ") }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    poIsApproved ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null,
                    poIsApproved ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }),
                    isTmp ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null,
                    poIsApproved ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("span", { style: {
                                fontWeight: "bold",
                                // marginLeft: "23px",
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                            } }, ordQtyTotal) }),
                    poIsApproved ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null,
                    isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("span", { style: {
                                fontWeight: "bold",
                                // marginLeft: "15px",
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                            } }, !Number.isNaN(Number(orderTotalCost))
                            ? formatUsd_1.formatUsd(orderTotalCost)
                            : "n/a") })) : null,
                    poHasBeenApproved ? React.createElement(list_item_text_1.MaterialListItemText, { primary: "" }) : null)));
        };
        this.handleCancelInventory = (poInventory) => async (event) => {
            event.stopPropagation();
            this.resetShowRows();
            const purchaseOrderId = this.purchaseOrder.id;
            await store_1.inventoryOrderStore.cancelPoInventory(purchaseOrderId, poInventory);
            await this.loadPurchaseOrder();
        };
        this.handleCancelInventoryBackorder = async (poInventory) => {
            this.resetShowRows();
            const purchaseOrderId = this.purchaseOrder.id;
            await store_1.inventoryOrderStore.cancelPoInventory(purchaseOrderId, poInventory);
            await this.loadPurchaseOrder();
        };
        this.renderManageLots = (poInventory) => {
            const { inventory } = poInventory;
            const { site } = this.purchaseOrder;
            const shouldDisableBackorderButton = poInventory.inventorySite &&
                poInventory.inventorySite.backorderInventories &&
                Boolean(poInventory.inventorySite.backorderInventories.length);
            const allProductsReceived = poInventory.totalQtyReceived >= poInventory.inventoryOrderQuantity;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "batch-qty-received" },
                    React.createElement("div", null,
                        React.createElement(button_1.MaterialButton, { onClick: () => {
                                this.backorderInventory = poInventory;
                                this.showBackorderModal = true;
                            }, secondary: true, disabled: shouldDisableBackorderButton }, "Backorder"),
                        shouldDisableBackorderButton
                            ? this.renderBackorderInventories(poInventory)
                            : null),
                    React.createElement("div", { className: "batch-qty-received--label" },
                        React.createElement(core_1.Typography, { gutterBottom: true, variant: "subheading", className: "batch-qty-received--label__text" }, "TOTAL QTY BEING RECEIVED IN THIS SHIPMENT:"),
                        React.createElement(text_field_1.MaterialTextField, { className: "batch-qty-received__text-field", disabled: allProductsReceived, label: "Qty", onChange: this.handleChangeBatchQtyReceived(poInventory), required: true, type: "number", numType: "integer", value: this.batchQtyReceived }))),
                (this.batchQtyReceived && this.batchQtyReceived > 0) ||
                    allProductsReceived ? (React.createElement("div", { className: "lots-received-qty-container" },
                    React.createElement(core_1.Typography, { variant: "subheading" }, "Available lots"),
                    React.createElement("div", { className: "lots-available" }, this.renderInventoryStockList(poInventory, allProductsReceived)),
                    React.createElement("div", { className: "add-lot-btn-container" },
                        React.createElement(button_1.MaterialButton, { disabled: allProductsReceived, onClick: () => {
                                this.createLotClickedInventoryId = poInventory.inventoryId;
                                this.createLotShow = true;
                            }, secondary: true }, "Create new lot")),
                    React.createElement("div", { className: "lots-edit-buttons" },
                        React.createElement(button_1.MaterialButton, { onClick: () => this.handleSaveRow(poInventory), disabled: allProductsReceived ||
                                !this.isBatchQtyMatch(poInventory) ||
                                !this.validLotData(poInventory) ||
                                this.isLoading, primary: true }, "Save")))) : null,
                this.createLotShow &&
                    this.createLotClickedInventoryId === poInventory.inventoryId
                    ? this.renderCreateLotUi(inventory, site, poInventory)
                    : null));
        };
        this.renderBackorderInventories = (poInventory) => {
            const { inventorySite: { backorderInventories } } = poInventory;
            return (React.createElement("div", null,
                React.createElement(core_1.Typography, null, "Backorder status detected. Backorder button disabled."),
                backorderInventories.map((boi, index) => (React.createElement(core_1.Typography, { key: index },
                    "Expected Date: ",
                    boi.expectedDate)))));
        };
        this.isBatchQtyMatch = (poInventory) => {
            const currentInventory = this.inventoriesLots.has(poInventory.inventorySiteId) &&
                this.inventoriesLots.get(poInventory.inventorySiteId);
            const totalReceived = Object.values(currentInventory).reduce((acc, cur) => acc + Number(cur.quantity), 0);
            if (totalReceived === this.batchQtyReceived) {
                return true;
            }
            return false;
        };
        this.validLotData = (poInventory) => {
            const currentInventory = this.inventoriesLots.has(poInventory.inventorySiteId) &&
                this.inventoriesLots.get(poInventory.inventorySiteId);
            const inventoryLotsArray = (currentInventory && Object.values(currentInventory)) || [];
            if (inventoryLotsArray === null || inventoryLotsArray === void 0 ? void 0 : inventoryLotsArray.length) {
                return inventoryLotsArray.every((inventoryLot) => {
                    // If lot does have quantity, make sure it has a valid lot number.
                    if (Number(inventoryLot.quantity)) {
                        return (!!inventoryLot.quantity &&
                            !!inventoryLot.lotNumber &&
                            !!inventoryLot.expirationDate);
                    }
                    // If lot does not have a quantity, disregard lot number validity.
                    return true;
                });
            }
            return true;
        };
        this.handleChangeBatchQtyReceived = (poInventory) => (event, value) => {
            let valueToNumber = parseInt(value, 10);
            try {
                const maxQtyAbleToReceive = poInventory.inventoryOrderQuantity - poInventory.totalQtyReceived;
                if (!Number.isNaN(valueToNumber) && valueToNumber > maxQtyAbleToReceive) {
                    valueToNumber = maxQtyAbleToReceive;
                }
            }
            catch (err) {
                console.error("Error in handle change batch qty received", err);
            }
            this.batchQtyReceived =
                Number.isNaN(valueToNumber) && value !== "" ? 0 : valueToNumber;
        };
        this.handleCancelRow = () => {
            this.showRows.clear();
        };
        this.resetShowRows = () => {
            this.showRows.clear();
        };
        this.renderInventoryStockList = (poInventory, allProductsReceived) => {
            var _a;
            const lots = (_a = this.inventoriesLots.get(poInventory.inventorySiteId)) !== null && _a !== void 0 ? _a : [];
            const lotsEntriesArray = Object.entries(lots);
            return lotsEntriesArray.map((lotEntry, index) => {
                const [, lot] = lotEntry;
                return this.renderInventoryStock(poInventory, lot, index, allProductsReceived);
            });
        };
        this.invalidLot = (field, lot, poInventory) => {
            const currentLot = this.inventoriesLots.get(poInventory.inventorySiteId)[lot.id];
            if (!currentLot) {
                return false;
            }
            if (field === "lotNumber") {
                return Number(currentLot.quantity) && !currentLot.lotNumber;
            }
            if (field === "date") {
                return Number(currentLot.quantity) && !currentLot.expirationDate;
            }
            return true;
        };
        this.renderInventoryStock = (poInventory, lot, key, allProductsReceived) => {
            const { inventorySiteLots: { value: lots = [] } } = store_2.inventoryListStore;
            const lotFound = (lots === null || lots === void 0 ? void 0 : lots.length) ? lots.find(l => l.id === lot.id) : null;
            const lotQtyIsZero = lotFound && Number(lotFound.quantity) !== 0;
            return (React.createElement("div", { key: key, className: "lot-exp-qty__lots--item" },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.MaterialTextField, { className: "lot-number", label: "Lot #", missing: this.invalidLot("lotNumber", lot, poInventory), required: true, disabled: allProductsReceived, onChange: this.handleLotEdit("lotNumber", lot, poInventory, key), value: this.inventoriesLots.get(poInventory.inventorySiteId)[lot.id]
                            .lotNumber ||
                            lot.lotNumber ||
                            "" }),
                    React.createElement(date_picker_1.MaterialDatePicker, { className: "expire-date", label: "Expiration Date", missing: this.invalidLot("date", lot, poInventory), disabled: allProductsReceived, onChange: this.handleLotExpireDateEdit("expirationDate", lot, poInventory, key), value: this.inventoriesLots.get(poInventory.inventorySiteId)[lot.id]
                            .expirationDate ||
                            lot.expirationDate ||
                            "" }),
                    React.createElement(text_field_1.MaterialTextField, { label: "Receiving qty", onChange: this.handleLotEdit("quantity", lot, poInventory, key), required: true, disabled: allProductsReceived, type: "number", numType: "integer", value: this.inventoriesLots.get(poInventory.inventorySiteId)[lot.id]
                            .quantity ||
                            lot.quantity ||
                            0 }),
                    this.manageLotMode && !lotQtyIsZero && (React.createElement(material_ui_1.Button, { "data-tip": `Remove lot ${lot.lotNumber}`, className: "delete-lot", "data-for": "warning-icon", disabled: allProductsReceived || lotQtyIsZero, onClick: this.handleLotRemove(lot) },
                        React.createElement(icons_1.DeleteIcon, null))))));
        };
        this.handleLotEdit = (field, lot, poInventory, index) => (event, value) => {
            const inventoriesLots = this.inventoriesLots.get(poInventory.inventorySiteId);
            if (field === "quantity") {
                if (Number(value) >= 0) {
                    inventoriesLots[lot.id][field] = value;
                }
                else {
                    inventoriesLots[lot.id][field] = 0;
                }
            }
            else {
                inventoriesLots[lot.id][field] = value;
            }
            this.inventoriesLots.set(poInventory.inventorySiteId, inventoriesLots);
        };
        this.handleLotExpireDateEdit = (field, lot, poInventory, index) => (value) => {
            const formattedDate = this.formatDate(value);
            const inventoriesLots = this.inventoriesLots.get(poInventory.inventorySiteId);
            inventoriesLots[lot.id][field] = formattedDate;
            this.inventoriesLots.set(poInventory.inventorySiteId, inventoriesLots);
        };
        this.handleLotRemove = (lot) => async () => {
            this.resetShowRows();
            store_1.inventoryOrderStore.currentBatchQtyEdit = this.batchQtyReceived;
            await store_2.inventoryListStore.removeInventorySiteLot(lot);
            await this.loadInventorySiteLots();
        };
        this.resetNewLot = () => {
            this.newLot.lotNumber = "";
            this.newLot.expireDate = "";
            this.newLot.quantity = 0;
            this.createLotClickedInventoryId = null;
            // Hide create lot modal
            if (this.createLotShow) {
                this.createLotShow = false;
            }
        };
        this.handleNewLotChangeDate = (value) => {
            const formattedDate = this.formatDate(value);
            this.newLot.expireDate = formattedDate;
        };
        this.generateHeaderColumns = () => {
            const columnsTmp = Array.from(orderReviewColumnsTmp);
            const columns = Array.from(orderReviewColumns);
            // Remove empty column for cancel icon
            if (!this.purchaseOrder.approvalDate) {
                columnsTmp.pop();
                columns.pop();
                const indexOfTotalReceivedTmp = columnsTmp.findIndex(header => header.label === "total received");
                indexOfTotalReceivedTmp > -1 &&
                    columnsTmp.splice(indexOfTotalReceivedTmp, 1);
                const indexOfTotalReceived = columns.findIndex(header => header.label === "total received");
                indexOfTotalReceived > -1 && columns.splice(indexOfTotalReceived, 1);
                const indexOfUserHeaderTmp = columnsTmp.findIndex(header => header.label === "user");
                indexOfUserHeaderTmp > -1 && columnsTmp.splice(indexOfUserHeaderTmp, 1);
                const indexOfDateHeaderTmp = columnsTmp.findIndex(header => header.label === "date");
                indexOfDateHeaderTmp > -1 && columnsTmp.splice(indexOfDateHeaderTmp, 1);
                const indexOfUserHeader = columns.findIndex(header => header.label === "user");
                indexOfUserHeader > -1 && columns.splice(indexOfUserHeader, 1);
                const indexOfDateHeader = columns.findIndex(header => header.label === "date");
                indexOfDateHeader > -1 && columns.splice(indexOfDateHeader, 1);
            }
            return { columns, columnsTmp };
        };
        this.renderOrderReviewList = () => {
            let orderInventories;
            if (this.purchaseOrder) {
                orderInventories = this.purchaseOrder.orderInventories;
            }
            const { columns, columnsTmp } = this.generateHeaderColumns();
            const isTmp = store_4.usersStore.user.value.user;
            return (React.createElement("div", { className: "edit-review-order-list" },
                React.createElement(list_1.MaterialList, { columns: isTmp ? columnsTmp : columns, order: "ASC", orderBy: "", rows: orderInventories || [], renderRow: this.renderOrderReviewListRow, resizableheader: true, customClass: "custom-material-list__order-review-list" })));
        };
    }
    get availableDistributorOptions() {
        const { purchaseOrderDistributorInvoices: invoices } = this.purchaseOrder;
        if (!invoices || !invoices.length) {
            return [];
        }
        return invoices.map((invoice, index) => {
            var _a, _b;
            return ({
                id: index,
                label: (_a = invoice.purchaseDistributor) === null || _a === void 0 ? void 0 : _a.distributor,
                value: String((_b = invoice.purchaseDistributor) === null || _b === void 0 ? void 0 : _b.id)
            });
        });
    }
    componentWillMount() {
        ReactTooltip.rebuild();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    async componentDidMount() {
        var _a, _b;
        console.info("this.showemailqueuedconfirmation", this.showEmailQueueConfirmation);
        const [transactionId] = this.props.params;
        store_1.inventoryOrderStore.poIdCurrentlyViewing = transactionId;
        await this.loadPurchaseOrder();
        if (this.purchaseOrder) {
            const options = {
                count: 1000,
                order: "",
                search: "",
                siteId: this.purchaseOrder.site.id,
                sort: "",
                start: 0,
                where: ``
            };
            // C-046.207_UAT 25/07/2025
            if ((_a = this.purchaseOrder) === null || _a === void 0 ? void 0 : _a.orderInventories) {
                (_b = this.purchaseOrder) === null || _b === void 0 ? void 0 : _b.orderInventories.map(item => {
                    if (item.distributor !== "" && item.distributor !== null) {
                        this.isDistributor = true;
                    }
                });
            }
            if (this.purchaseOrder.purchaseOrderDistributorInvoices) {
                const { purchaseOrderDistributorInvoices: invoices = [] } = this.purchaseOrder;
                const mailIds = invoices.map(invoice => invoice.mailMessageMailID);
                if (mailIds.length) {
                    await store_1.inventoryOrderStore.getPoMailMessages(mailIds);
                }
            }
            await store_2.inventoryListStore.loadInventorySiteLots(options);
            await store_1.inventoryOrderStore.listOrderTrackingDetails(this.purchaseOrder.id);
            await store_1.inventoryOrderStore.listOrderTrackingCreditDetails(this.purchaseOrder.id);
            this.initializeInventorySiteLots();
            this.initializeShowRows();
            this.initializeInvoiceStatus();
        }
    }
    render() {
        if (this.renderPlaceHolder) {
            return React.createElement("div", null, "Please select an order from order history");
        }
        return (React.createElement("div", { className: "po-review-page" },
            this.showBackorderModal ? (React.createElement(back_order_modal_1.BackOrderModal, { onCancel: () => (this.showBackorderModal = false), poInventory: this.backorderInventory, purchaseOrder: this.purchaseOrder, updateUi: this.updateUi, onCancelInventory: this.handleCancelInventoryBackorder })) : null,
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.invoiceDocumentViewing.originalname || "N/A", iframeUrl: this.iframeUrl, onClose: this.handlePreviewClose, onDelete: this.handleDeleteInvoiceDocument, download: this.iframeUrl })) : null,
            this.renderOrderReviewPage(),
            this.showConfirmReject && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", 
                // message="You clicked on reject. If you are satisfied with the decision, click submit."
                message: "Please provide a reason to reject this order to be able to confirm the rejection submission." // C-046.2072_UAT
                , onCancel: () => (this.showConfirmReject = false), onConfirm: this.handleDecision("reject"), title: "Reject confirmation", reasonTextField: this.reasonTextField(), shouldDisableConfirm: !this.rejectionReason })),
            this.showConfirmApproveDoubleCheck && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", message: this.renderDistributorWarningDoubleCheck(), redirect: this.renderDistributorRedirect(), onCancel: () => (this.showConfirmApproveDoubleCheck = false), onConfirm: this.handleDecision("approve"), shouldDisableConfirm: !this.isDistributor, title: this.missingDistributor() ?
                    (React.createElement(React.Fragment, null,
                        " Warning ",
                        React.createElement("br", null),
                        " Unable to Approve Order  ")) : "Approve confirmation", isSubmit: this.missingDistributor() ? true : false })),
            this.showEmailQueueConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Okay", cancelText: "Cancel", message: this.renderEmailQueueMessage(), onCancel: () => {
                    this.showEmailQueueConfirmation = false;
                }, onConfirm: () => {
                    router_1.RouteManager.transitionTo("/order/history");
                }, title: "Email queued notification" })),
            this.showOrderTrackingModal && (React.createElement(order_tracking_detail_1.OrderTrackingDetail, { trackingDetails: store_1.inventoryOrderStore.orderTrackingDetails, creditDetails: store_1.inventoryOrderStore.orderTrackingCreditDetails, distributorOptions: this.availableDistributorOptions, onCancel: () => (this.showOrderTrackingModal = false), onCreateTracking: this.handleOrderTrackingCreate, onCreateCredit: this.handleOrderTrackingCreditCreate, onSubmit: this.handleOrderTrackingSubmit })),
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: () => (this.uploadModal = false), message: `Please select files for Purchase Order ${this.purchaseOrder.id}`, title: "Upload Invoices", onDrop: this.handleInvoiceUpload })),
            this.assetModal ? (React.createElement(modal_1.AssetModal, { title: `Assets For Purchase Order ${this.purchaseOrder.id}`, onCancel: () => (this.assetModal = !this.assetModal), maxHeight: "70%", top: "100px" },
                React.createElement(asset_list_1.AssetList, { invoiceUploads: this.invoiceMetas, onDeleteUpload: this.handleDeleteInvoiceDocument, onInvoiceUpload: this.handleUploadClick, onDescriptionSave: this.handleAssetsDescriptionsSave, onCancel: () => (this.assetModal = !this.assetModal) }))) : null,
            this.scanModal ? (React.createElement(order_receive_scan_1.OrderReceiveScan, { onCancel: () => (this.scanModal = false), onSubmit: this.handleOrderReceiveScanSubmit, purchaseOrder: this.purchaseOrder })) : null,
            React.createElement(ReactTooltip, { effect: "solid", place: "right", delayShow: 300, "data-type": "info", multiline: true }),
            this.renderReplacementModal()));
    }
    formatDate(date) {
        const currentDate = new Date(date);
        let month = String(currentDate.getMonth() + 1);
        let day = String(currentDate.getDate());
        const year = currentDate.getFullYear();
        if (month.length < 2) {
            month = `0${month}`;
        }
        if (day.length < 2) {
            day = `0${day}`;
        }
        return [year, month, day].join("-");
    }
};
__decorate([
    mobx_1.computed
], OrderReviewTab.prototype, "availableDistributorOptions", null);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "scanModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "purchaseOrder", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "invoiceMetas", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showEmailQueueConfirmation", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showConfirmApprove", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showConfirmApproveDoubleCheck", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showConfirmReject", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "rejectionReason", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "renderPlaceHolder", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "invoiceStatus", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "invoiceStatusInitial", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showRows", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "manageLotMode", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "newLot", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "createLotClickedInventoryId", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "inventoriesLots", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "batchQtyReceived", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "availableLots", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "invoiceDocumentViewing", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "isLoading", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "createLotShow", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showOrderTrackingModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showBackorderModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "backorderInventory", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "showReplacementModal", void 0);
__decorate([
    mobx_1.observable
], OrderReviewTab.prototype, "isDistributor", void 0);
__decorate([
    mobx_1.action
], OrderReviewTab.prototype, "renderBackorderInventories", void 0);
__decorate([
    mobx_1.action
], OrderReviewTab.prototype, "isBatchQtyMatch", void 0);
__decorate([
    mobx_1.action
], OrderReviewTab.prototype, "validLotData", void 0);
OrderReviewTab = __decorate([
    mobx_react_1.observer
], OrderReviewTab);
exports.OrderReviewTab = OrderReviewTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/order-review.tsx
// module id = 3570
// module chunks = 0